import { BrowserProvider, Contract, formatUnits, parseUnits,ethers  } from "ethers";
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from "@web3modal/ethers/react";
import Web3 from "web3";
import {


  TOKEN_ABI,
  PRESALE_ABI,
} from "../contracts/contracts";

// Define the two networks (BSC and Matic)
const NETWORKS = {
  56: { // BSC Mainnet
    PRESALE_CONTRACT_ADDRESS: "0xB17Ae099b635bfEFB37C6f2C749C16ee687cd56b", // Replace with actual address
    TOKEN_CONTRACT_ADDRESS: "0x2935d24e79c8a6731F45fd887654b7d69107d06a", // Ethereum Token contract address
    USDT_CONTRACT_ADDRESS: "0x55d398326f99059fF775485246999027B3197955",
  },
  137: { // Polygon (Matic) Mainnet
    PRESALE_CONTRACT_ADDRESS: "0x2935d24e79c8a6731F45fd887654b7d69107d06a", // Replace with actual address
    TOKEN_CONTRACT_ADDRESS: "0x2935d24e79c8a6731F45fd887654b7d69107d06a", // Ethereum Token contract address
    USDT_CONTRACT_ADDRESS: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  }
};

function useContract() {
  const { walletProvider } = useWeb3ModalProvider();
  const { address, isConnected } = useWeb3ModalAccount();

  const getProvider = () => {
    return new BrowserProvider(walletProvider);
  };

  const getSigner = async (provider) => {
    return provider.getSigner();
  };
  // Fetch the connected network's chain_id and PRESALE_CONTRACT_ADDRESS
  const getNetworkConfig = async () => {
    const provider = getProvider();
    const network = await provider.getNetwork();
    const { chainId } = network;

    if (NETWORKS[chainId]) {
      const PRESALE_CONTRACT_ADDRESS = NETWORKS[chainId].PRESALE_CONTRACT_ADDRESS;
      const TOKEN_CONTRACT_ADDRESS = NETWORKS[chainId].TOKEN_CONTRACT_ADDRESS;
      const USDT_CONTRACT_ADDRESS = NETWORKS[chainId].USDT_CONTRACT_ADDRESS;
      return { chainId, PRESALE_CONTRACT_ADDRESS,TOKEN_CONTRACT_ADDRESS,USDT_CONTRACT_ADDRESS };
    } else {
      throw new Error("Unsupported network.");
    }
  };
  const getContract = async (address, abi, signer) => {
    return new Contract(address, abi, signer);
  };

  // Buy package
  const buy = async (paymentType, amount) => {
    const provider = getProvider();
    const signer = await getSigner(provider);
    const { chainId, PRESALE_CONTRACT_ADDRESS,USDT_CONTRACT_ADDRESS } = await getNetworkConfig();


    const contract =  await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
    try {
      let tokenAddress, tokenDecimals;
      console.log(`Purchasing: PaymentType: ${paymentType}, Amount: ${amount}`);
  
      // Determine which token is used based on the package
      if (paymentType === "package1" || paymentType === "package2"|| paymentType === "package3"|| paymentType === "package4"|| paymentType === "package5") {
        tokenAddress = USDT_CONTRACT_ADDRESS; // Use USDT
        tokenDecimals = 6; // USDT has 6 decimals
      } else if (paymentType === "package6") {
        tokenAddress = USDT_CONTRACT_ADDRESS; // Use USDC
        tokenDecimals = 6; // USDC has 6 decimals
      } else {
        throw new Error("Invalid payment type");
      }
  
      const tokenContract = await getContract(tokenAddress, TOKEN_ABI, signer);
  
      // Scale the amount correctly based on token decimals
      const parsedAmount = parseUnits(amount.toString(), tokenDecimals);
      console.log(`Parsed Amount (${tokenDecimals} decimals):`, parsedAmount.toString());
  
      // Approve token transfer to the presale contract
      const approval = await tokenContract.approve(
        PRESALE_CONTRACT_ADDRESS,
        parsedAmount
      );
      await approval.wait();
  
      // Determine the package ID dynamically
      const packageId = parseInt(paymentType.replace("package", ""), 10);
      console.log(`Purchasing Package ID: ${packageId}, Parsed Amount: ${parsedAmount.toString()}`);
  
      // Call purchasePackage
      const trx = await contract.purchasePackage(packageId);
      await trx.wait();
    } catch (error) {
      console.error("Error during buy:", error.message || error);
      throw error;
    }
  };
  
  // Stake tokens
  const stake = async (amount) => {
    try {
      // Get provider and signer
      const provider = getProvider();
      const signer = await getSigner(provider);
  
      // Ensure PRESALE_CONTRACT_ADDRESS is correctly set
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
  
      // Get the contract instance
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      // Fetch the token's decimals (for proper amount formatting)
      const tokenDecimals = 18; // You can dynamically fetch the decimals if it's a specific token other than ETH
      const parsedAmount = parseUnits(amount.toString(), tokenDecimals);
  
      console.log(`Staking ${parsedAmount.toString()} tokens...`);
  
      // Perform the stake transaction
      const transaction = await contract.stake(parsedAmount);
      await transaction.wait();
  
      console.log("Stake transaction successful!");
    } catch (error) {
      console.error("Stake transaction failed:", error.message || error);
      throw error;
    }
  };
  
    // Unstake tokens
    const unstake = async (amount) => {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const tx = await contract.unstake(parseUnits(amount, 18));
      await tx.wait();
    };

      // Claim vested tokens
      const claimVesting = async () => {
        try {
          const provider = getProvider();
          const signer = await getSigner(provider);
          const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
          const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      
          console.log("Claiming vested tokens...");
          const tx = await contract.claimVesting(); // No arguments required
          await tx.wait(); // Wait for the transaction to be mined
          console.log("Vested tokens claimed successfully!");
        } catch (error) {
          console.error("Error claiming vested tokens:", error);
          throw error; // Propagate the error to handle it in the component
        }
      };
      
      const getTotalClaimed = async () => {

        if (!isConnected) {
          return 0;
        } else {
          const provider = getProvider();
          // check chain id and throw error if not correct
          const chainId = await provider.getNetwork();
          
          // base chain id
          if (chainId.chainId != chainId) {
            return;
          }
          const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
        const signer = await getSigner(provider);
        const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
    
        console.log("Fetching unclaimed tokens for address:", address);
    
    
    
    
    
    
           // Call the getReferralReward function
           const [, , totalAmount] = await contract.getTotalAirdropClaimed(address);
           console.log("Raw totalAmount (BigNumber):", totalAmount);
       
           // Format the tokens using ethers.js formatUnits for 18 decimals
           const formattedUnclaimedTokens = formatUnits(totalAmount, 18);
           console.log("Formatted unclaimed tokens:", formattedUnclaimedTokens);
       
           // Reduce decimals to 2
           const airdropAmount = Number(formattedUnclaimedTokens).toFixed(0);
           console.log("Reduced unclaimed tokens (2 decimals):", airdropAmount);
       
           return airdropAmount;
      } 
    };
    
  // Vest tokens
  const vestTokens = async (amount) => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

      const parsedAmount = parseUnits(amount.toString(), 18);
      console.log(`Vesting ${parsedAmount.toString()} tokens...`);

      const transaction = await contract.vestTokens(parsedAmount);
      await transaction.wait();
      console.log("Vesting transaction successful!");
    } catch (error) {
      console.error("Vesting transaction failed:", error.message || error);
      throw error;
    }
  };
  // Get user's token balance
  const myTokenBalance = async () => {
    if (!isConnected) return 0;

    const provider = getProvider();
    const signer = await getSigner(provider);
    const { PRESALE_CONTRACT_ADDRESS, USDT_CONTRACT_ADDRESS, USDC_CONTRACT_ADDRESS, TOKEN_CONTRACT_ADDRESS } = await getNetworkConfig();
    const token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const balance = await token.balanceOf(address);

    return formatUnits(balance, 18);
   // Assuming token has 18 decimals
  };

  // Get the max balances for USDT, BUSD, and ETH
  const maxBalances = async () => {
    if (!isConnected) return { usdt: 0, busd: 0, eth: 0 };

    const provider = getProvider();
    const signer = await getSigner(provider);
    const { PRESALE_CONTRACT_ADDRESS, USDT_CONTRACT_ADDRESS, USDC_CONTRACT_ADDRESS, TOKEN_CONTRACT_ADDRESS } = await getNetworkConfig();
    const usdt = await getContract(USDT_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    const usdc = await getContract(USDC_CONTRACT_ADDRESS, TOKEN_ABI, signer);

    const usdtBalance = await usdt.balanceOf(address);
    const usdcBalance = await usdc.balanceOf(address);
    const ethBalance = await provider.getBalance(address);

    return {
      usdt: Number(formatUnits(usdtBalance, 6)).toFixed(4), // Assuming 6 decimals for USDT
      busd: Number(formatUnits(usdcBalance, 6)).toFixed(4), // Assuming 6 decimals for USDC
      eth: Number(formatUnits(ethBalance, 18)).toFixed(4),
    };
  };



  const getNextVestingClaimTime = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      const address = await signer.getAddress(); // Automatically fetch connected wallet address
  
      console.log("Fetching next vesting claim time for address:", address);
      const nextClaimTime = await contract.getNextVestingClaimTime(address);
  
      console.log("Next Vesting Claim Time (Unix):", nextClaimTime.toString());
  
      return Number(nextClaimTime); // Return as a number
    } catch (error) {
      console.error("Error fetching next vesting claim time:", error);
      throw error;
    }
  };
  

  const getNextStakingClaimTime = async (userAddress) => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      console.log("Fetching next staking claim time for address:", userAddress);
      const nextClaimTime = await contract.getNextStakingClaimTime(userAddress);
  
      console.log("Next Staking Claim Time (Unix):", nextClaimTime.toString());
      return Number(nextClaimTime); // Return as a number for easier manipulation
    } catch (error) {
      console.error("Error fetching next staking claim time:", error);
      throw error;
    }
  };
  

  const getTotalAirdropClaim = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const address = await signer.getAddress();
  
      console.log("Wallet Address:", address);
      console.log("Calling getTotalAirdropClaimed...");
      const totalAirdropClaimed = await contract.getTotalAirdropClaimed(address);
  
      console.log("Raw Claimed Value:", totalAirdropClaimed.toString());
      return formatUnits(totalAirdropClaimed, 18); // Adjust decimals if necessary
    } catch (error) {
      console.error("Error in getTotalAirdropClaimed:", error);
      throw error;
    }
  };



  const getTotalStakingClaim = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const address = await signer.getAddress();
  
      console.log("Wallet Address:", address);
      console.log("Calling getTotalAirdropClaimed...");
      const totalAirdropClaimed = await contract.totalStakingRewardsClaimed(address);
  
      console.log("Raw Claimed Value:", totalAirdropClaimed.toString());
      return formatUnits(totalAirdropClaimed, 18); // Adjust decimals if necessary
    } catch (error) {
      console.error("Error in getTotalAirdropClaimed:", error);
      throw error;
    }
  };



  const fetchTransactionHistory = async () => {
    if (!isConnected) {
      console.log("Not connected to a wallet");
      return [];
    }
  
    const provider = getProvider();
    const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);
  
    try {
      const events = await contract.queryFilter("TransactionEvent", 0, "latest");
      console.log("Fetched events:", events);
  
      return events.map((event) => ({
        transactionHash: event.transactionHash,
        from: event.args.from,
        to: event.args.to,
        amount: formatUnits(event.args.value, 18),
        blockNumber: event.blockNumber,
      }));
    } catch (error) {
      console.error("Error fetching transactions:", error);
      return [];
    }
  };
  
  

  const fetchTokenPriceusd = async () => {
    try {
      // Use a read-only provider (Infura in this example)
      const provider = new ethers.JsonRpcProvider("https://polygon-mainnet.infura.io/v3/82dd7e624fa24a889bc681e252bf16c0"); // Binance Smart Chain Mainnet RPC
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = new ethers.Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);
  
      // Fetch the raw price from the contract
      const rawPrice = await contract.currentTokenPrice();
  
      // Convert to a readable format (divide by 10^6)
      const formattedPrice = (Number(rawPrice) / 10 ** 6).toFixed(4); // Adjust for your token's decimal scale
      
      console.log("Token Price (formatted):", formattedPrice);
      return formattedPrice;
    } catch (error) {
      console.error("Error fetching token price:", error);
      throw error;
    }
  };


  const getstakingTokensClaim = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);
      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const address = await signer.getAddress();
  
      console.log("Wallet Address:", address);
      console.log("Calling getTotalAirdropClaimed...");
      const totalAirdropClaimed = await contract.calculateReward(address);
  
      console.log("Raw Claimed Value:", totalAirdropClaimed.toString());
      return formatUnits(totalAirdropClaimed, 18); // Adjust decimals if necessary
    } catch (error) {
      console.error("Error in getTotalAirdropClaimed:", error);
      throw error;
    }
  };







  const getvestingtotalTokensClaim = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const address = await signer.getAddress();
  
      console.log("Wallet Address:", address);
      console.log("Calling getTotalAirdropClaimed...");
      const totalAirdropClaimed = await contract.calculateVestingAirdrop(address);
  
      console.log("Raw Claimed Value:", totalAirdropClaimed.toString());
      return formatUnits(totalAirdropClaimed, 18); // Adjust decimals if necessary
    } catch (error) {
      console.error("Error in getTotalAirdropClaimed:", error);
      throw error;
    }
  };
  






  const getUserVestedTokens = async () => {
    try {
      const provider = getProvider();
      const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
      const address = await signer.getAddress();
  
      console.log("Wallet Address:", address);
      console.log("Calling getTotalAirdropClaimed...");
      const totalAirdropClaimed = await contract.getUserVestedTokens(address);
  
      console.log("Raw Claimed Value:", totalAirdropClaimed.toString());
      return formatUnits(totalAirdropClaimed, 18); // Adjust decimals if necessary
    } catch (error) {
      console.error("Error in getTotalAirdropClaimed:", error);
      throw error;
    }
  };
  
  const calculatePreviousClaimTime = async (vestingInterval) => {
    try {
      const nextClaimTime = await getNextVestingClaimTime(); // Fetch the next claim time
  
      if (nextClaimTime <= 0) {
        return "No Previous Claim Time Available";
      }
  
      const previousClaimTime = nextClaimTime - vestingInterval;
      console.log("Calculated Previous Claim Time (Unix):", previousClaimTime);
  
      return previousClaimTime; // Return the calculated previous claim time
    } catch (error) {
      console.error("Error calculating previous claim time:", error);
      throw error;
    }
  };
  
  // Claim tokens from the contract
  const claimTokens = async () => {
    const provider = getProvider();
    const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );

    const trx = await contract.claimTokens();
    return await trx.wait();
  };

  // Fetch presale allocation
  const getPresaleAllocation = async () => {
    if (!isConnected) return 0;

    const provider = getProvider();
    const signer = await getSigner(provider);
    const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
    const [, , allocation] = await contract.getTotalAirdropClaimed(address);

    return Number(formatUnits(allocation, 18)).toFixed(0);
  };

  // Fetch token price
  const fetchTokenPrice = async () => {
    const provider = getProvider();      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = new Contract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, provider);

    const rawPrice = await contract.perDollarPrice();
    return Number(formatUnits(rawPrice, 18)).toFixed(4);
  };
 // Claim airdrop tokens
 const claimAirdrop = async () => {
  try {
    const provider = getProvider();
    const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    console.log("Claiming airdrop tokens...");
    const tx = await contract.claimAirdrop();
    await tx.wait();
    console.log("Airdrop tokens claimed successfully.");
  } catch (error) {
    console.error("Error claiming airdrop tokens:", error);
    throw error;
  }
};

const getUserStakedAmount = async (userAddress) => {
  try {
    const provider = getProvider();
    const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    // Call the stakingData function
    const stakingData = await contract.stakingData(userAddress);

    // Extract and format the staked amount
    const amountStaked = formatUnits(stakingData.amountStaked, 18); // Adjust decimals if necessary
    console.log("Amount Staked:", amountStaked);

    return amountStaked;
  } catch (error) {
    console.error("Error fetching amountStaked:", error);
    throw error;
  }
};





const claimStakingRewards = async () => {
  try {
    const provider = getProvider();
    const signer = await getSigner(provider);      const { PRESALE_CONTRACT_ADDRESS } = await getNetworkConfig(); // Dynamically get the contract address based on network
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    console.log("Claiming staking tokens...");
    const tx = await contract.claimStakingRewards();
    await tx.wait();
    console.log("staking tokens claimed successfully.");
  } catch (error) {
    console.error("Error claiming staking tokens:", error);
    throw error;
  }
};



  return {
    buy,
    myTokenBalance,
    maxBalances,
    claimTokens,
    getPresaleAllocation,
    fetchTokenPrice,
    stake, vestTokens,unstake, getUserStakedAmount,getUserVestedTokens,fetchTokenPriceusd,claimVesting ,claimAirdrop,getTotalClaimed,getNextStakingClaimTime,getTotalStakingClaim,getTotalAirdropClaim,getNextVestingClaimTime,calculatePreviousClaimTime,getstakingTokensClaim,fetchTransactionHistory,claimStakingRewards,getvestingtotalTokensClaim
  };
}

export default useContract;
